const rootActionPath = 'core/App';

export const APP_UPDATE = `${rootActionPath}/UPDATE`;
export const UPDATE_EASY_LINK_SUPPRESION_PROPERTY = `${rootActionPath}/easyLinkSuppressionPropery/UPDATE`;
